import * as React from 'react'
import { GridApiCommon } from '../../models/api/gridApiCommon'
import {
  OutputSelector,
  OutputSelectorAdvanced,
} from '../../utils/createSelector'
import { DataGridProcessedProps } from '../../models/props/DataGridProps'
import { GridReactTableInstance } from '../../models/gridReactTable'

function isOutputSelector<Api extends GridApiCommon, T>(
  selector: any
): selector is OutputSelector<Api['state'], T> {
  return selector.acceptsApiRef
}

function isOutputSelectorAdvanced<
  Api extends GridApiCommon,
  TableInstance,
  Props,
  T,
>(
  selector: any
): selector is OutputSelectorAdvanced<Api['state'], TableInstance, Props, T> {
  return selector.acceptsApiRef
}

export const useGridSelector = <Api extends GridApiCommon, T>(
  apiRef: React.MutableRefObject<Api>,
  selector: ((state: Api['state']) => T) | OutputSelector<Api['state'], T>
) => {
  if (isOutputSelector<Api, T>(selector)) {
    return selector(apiRef)
  }

  return selector(apiRef.current.state)
}

export const useGridSelectorAdvanced = <Api extends GridApiCommon, Props, T>(
  apiRef: React.MutableRefObject<Api>,
  props: Props,
  selector:
    | ((state: {
        tableInstance: Api['tableInstance']
        state: Api['state']
        props: Props
      }) => T)
    | OutputSelector<
        { tableInstance: Api['tableInstance']; state: Api['state'] },
        T
      >
) => {
  if (
    isOutputSelectorAdvanced<
      Api,
      GridReactTableInstance,
      DataGridProcessedProps,
      T
    >(selector)
  ) {
    return selector(apiRef)
  }

  return selector({
    state: apiRef.current.state,
    tableInstance: apiRef.current.tableInstance,
    props: props,
  })
}
